export const CustomDataLayerPush = (eventObject: Object) => {
  window!.dataLayer!.push(eventObject);
};
